import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const InvoiceGeneratorPage = ({ setPage }) => {
  const [customer, setCustomer] = useState('Acme Inc.');
  const [items, setItems] = useState('[{"desc":"Consulting","qty":1,"price":1000}]');
  const [err, setErr] = useState('');

  const run = async () => {
    setErr('');
    try {
      const parsed = JSON.parse(items).map((it) => ({
        description: it.description || it.desc || 'Item',
        qty: Number(it.qty || 1),
        price: Number(it.price || 0),
      }));
      const res = await fetch(`${API_BASE}/api/invoice/generate`, {
        method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ seller: 'Syncusive', buyer: customer, items: parsed }),
      });
      if (!res.ok) throw new Error((await res.json().catch(()=>({}))).error || 'Failed');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob); const a = document.createElement('a'); a.href = url; a.download = 'invoice.pdf'; a.click(); URL.revokeObjectURL(url);
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={{...ui.container, maxWidth:860}}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>Invoice Generator (PDF)</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <input value={customer} onChange={(e)=>setCustomer(e.target.value)} placeholder='Customer' style={{...ui.input, marginBottom:10}} />
      <textarea value={items} onChange={(e)=>setItems(e.target.value)} rows={10} style={{...ui.textarea, ...ui.mono}} />
      <button onClick={run} style={{...ui.primaryBtn, marginTop:10}}>Generate Invoice</button>
      {err && <div style={ui.error}>{err}</div>}
    </div>
  </div></main>;
};

export default InvoiceGeneratorPage;
